import { Box, Button, Grid, Hidden, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDropzone } from 'react-dropzone'
import { useTranslation } from "react-i18next";
import { BrowseIcon, CloseLineIcon, DeleteIcon, DragDropIcon, iconFontSize } from "./IconComponent";
import { newGUIDV2 } from "../utils/util";
import { GetIconColor } from "../theme/main_style";


function AddAttachment(props) {
    const { t } = useTranslation();
    const { onUploadFile, isMultipleFile, chooseFromGaleryTitle, clearTitle, files, maximumFilesNumber } = props;

    const [selectedFile, setSelectedFile] = useState(null);
    const [previewIndex, setPreviewIndex] = useState(undefined);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [showPreview, setShowPreview] = useState(true);

    const [allFile, setAllFiles] = useState(files || []);
    
    const inputRef = useRef();

    useEffect(() => {
    setAllFiles(files || []);
    }, [files]);


    const onDrop = (acceptedFiles) => {
        if (!acceptedFiles || acceptedFiles.length === 0) return;
    
        let _allFile = allFile && allFile.length <= 3 ? [...allFile] : [];
    
        if (showPreview) {
            const newFiles = acceptedFiles.map((file) => {
                const fileWithMeta = Object.assign(file, {
                    uri: URL.createObjectURL(file),
                    id: newGUIDV2(),
                });

                if (!isMultipleFile) {
                    _allFile = [fileWithMeta];
                } else if (_allFile.length < maximumFilesNumber) {
                    _allFile.push(fileWithMeta);
                }
                return fileWithMeta;
            });
            // Set the first file as selected and update preview/download URL
            if (newFiles.length > 0) {
                setSelectedFile(newFiles[0]);
                setPreviewIndex(0);
                setDownloadUrl(newFiles[0].uri);
            }
        }
        setAllFiles(_allFile);
        if (onUploadFile) onUploadFile(_allFile);
    };

    const onDeleteFile = (file) => {
        if (file.uri) {
            URL.revokeObjectURL(file.uri);
        }
        let filterFiles = allFile.filter(f => f.id !== file.id);
        setAllFiles(filterFiles);
        props.removeFile(file)
    }

    const { getRootProps, getInputProps } = useDropzone({ onDrop,  
        accept: {
            'image/jpeg': [],
            'image/png': []
          }})



    const hasCameraAccess = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            stream.getTracks().forEach(track => track.stop());
            return true;
        } catch (err) {
            return false;
        }
    }

    const handleClick = async () => {
        const isAndroid = window.natively?.isAndroidApp;

        // Always open file picker immediately on iOS or non-Android
        if (!isAndroid) {
            inputRef.current?.click();
            return;
        }

        // Android only logic
        else{
            let camera = null;
            camera = await hasCameraAccess();
        
            if (camera!=null) 
            {
                inputRef.current?.click();
            }

        }

    };


    return (
        <>
        <section>
           <Box marginTop={2}>
                <Hidden mdDown>
                    <Box 
                        padding={5} 
                        display="flex" 
                        alignItems="center" 
                        justifyContent="center" 
                        borderRadius={3} 
                        border="dashed" 
                        {...getRootProps({className: 'dropzone'})}>
                        <input {...getInputProps()}/>
                        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                            <DragDropIcon size={iconFontSize.sm} style={{ marginTop: 8 }} />
                            <Typography variant="subtitle2">{t('drag_n_drop')}</Typography>
                        </Box>
                    </Box>
                    
                    <Box mt={2} display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width="100%">
                        <Box {...getRootProps({className: 'dropzone'})} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent:'flex-start', width:'100%' }}>
                            <input {...getInputProps()} />
                            <Button
                                startIcon={<BrowseIcon size={iconFontSize.xxs} color={GetIconColor().default} />}
                                variant="outlined"
                                fullWidth
                                >
                                {chooseFromGaleryTitle}
                            </Button>
                        </Box>
                    </Box>

                    {clearTitle && 
                        <Box sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent:'flex-start', width:'100%', mt:2 }}>
                            <Button
                                startIcon={<DeleteIcon size={iconFontSize.xxs} color={GetIconColor().default} />}
                                variant="outlined"
                                fullWidth
                                >
                                {clearTitle}
                            </Button>
                        </Box>
                    }

                </Hidden>

                <Hidden mdUp>
                    <Box mt={2} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                       
                        <div
                            style={{
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                width: '100%',
                            }}
                            onClick={handleClick}
                        >
                            <input {...getInputProps()} ref={inputRef} style={{ display: 'none' }} />

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "center",
                                    px: 1,
                                    py: 1.2,
                                    borderRadius: 2,
                                    cursor: 'pointer',
                                }}
                            >
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Box sx={{ mr: 2 }}>
                                        <BrowseIcon size={iconFontSize.xxs} color={GetIconColor().default} />
                                    </Box>
                                    <Typography variant='subtitle2'>{chooseFromGaleryTitle}</Typography>
                                </Box>
                            </Box>
                        </div>

                        {clearTitle && 
                        <Box
                            sx={{ display: "flex", alignItems: "flex-start", justifyContent: "center", px: 1, py: 1.2, borderRadius: 2, width:'100%',
                                '&:hover': { bgcolor: 'action.hover' }, cursor: 'pointer' }}
                            onClick={props.onDeleteProfileImage}
                            >
                            <Box sx={{ display: "flex", alignItems: "center" , width:'100%'}}>
                                <Box sx={{ mr: 2 }}>  
                                    <DeleteIcon size={iconFontSize.xxs} color={GetIconColor().default} />
                                </Box>
                                <Typography variant='subtitle2'>{clearTitle}</Typography>
                            </Box>
                        </Box>
                        }
                    </Box>
                </Hidden>
             
                {props.fromServiceRequestAddAttachment && <Box padding={2} display="flex" alignItems="center" justifyContent={'center'}>
                    <Typography variant="subtitle2" justifyContent={'center'}>{t("error_max_files")}</Typography>
                </Box>}
            </Box>
            {showPreview && <Grid item container justifyContent={'center'} xs={12} marginTop={2}>
                {allFile.map((f, i) => (
                    <Box key={i} display="flex" alignItems="center" mb={1} p={1} borderRadius={1} width="100%">
                        {f.type && f.type.includes('image') && <img alt={f.name} src={f.uri} width={40} height={40} style={{ borderRadius: 4, objectFit: 'cover', marginRight: 8 }} />}
                        <Box flex={1} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">{f.name}</Box>
                        <Box onClick={() => onDeleteFile(f, i)}sx={{ cursor: 'pointer' }}>
                            <CloseLineIcon size={iconFontSize.xs}/>
                        </Box>
                    </Box>
                ))}
                </Grid>}
        </section>
        </>
    )
}

export default AddAttachment;